/* eslint-disable  @typescript-eslint/no-explicit-any */
import { AxiosStatic, AxiosResponse } from 'axios';

/**
 * Send get axios request with multiple attempts.
 */
export async function getMultipleAttempts(axios: AxiosStatic, url: string, params?: any,
    attempts = 3): Promise<AxiosResponse<any>> {
  let response: AxiosResponse<any>|undefined = undefined;
  let reason = undefined
  let count = 0;
  while (response === undefined && count < attempts) {
    try {
      response = await axios.get(url, { params });
    } catch (e) {
      reason = e;
    }
    count += 1;
  }
  if (response !== undefined) {
    return response;
  } else {
    throw reason;
  }
}
